<template>
    <div class="color-picker" ref="colorpicker">
        <form-input :error="error">
            <app-label :for="id">{{ label }}</app-label>
            <input-field
                :style="{'background-color': value}"
                v-bind="$props"
                :value="value"
                @focus="showPicker()"
                @input="updateFromInput"
            />
            <help-block :text="error" />
        </form-input>
		<chrome-picker :value="value" @input="updateFromPicker" v-if="displayPicker"/>
    </div>
</template>

<script>
    import { Chrome } from 'vue-color';

    export default {
        components: {
            'chrome-picker': Chrome,
        },
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: true
            },
            is_disabled: {
                type: Boolean,
                default: false
            },
            id: String,
            value: String,
            iconState: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            help_link: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                displayPicker: false,
            }
        },
        methods: {
            showPicker() {
                document.addEventListener('click', this.documentClick);
                this.displayPicker = true;
            },
            hidePicker() {
                document.removeEventListener('click', this.documentClick);
                this.displayPicker = false;
            },
            togglePicker() {
                this.displayPicker ? this.hidePicker() : this.showPicker();
            },
            updateFromPicker(color) {
                this.$emit('input', color.hex);
            },
            updateFromInput(color) {
                this.$emit('input', color);
            },
            documentClick(e) {
                var el = this.$refs.colorpicker,
                    target = e.target;
                if (el !== target && !el.contains(target)) {
                    this.hidePicker()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .color-picker {
        position: relative;
    }

    .vc-chrome {
        position: absolute;
        top: 60px;
        left: 0;
        z-index: 9;
    }
</style>
